







































































import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';
import { validationMixin } from 'vuelidate';

import BaseInputGroup from '@/components/Form/BaseInputGroup.vue';
import ModalConfirm from '@/components/Form/ModalConfirm.vue';
import ModalControlsPanel from '@/components/Form/ModalControlsPanel.vue';

export default Vue.extend({
    name: 'BaseModalForm',
    components: {
        BaseInputGroup,
        ModalConfirm,
        ModalControlsPanel,
    },
    mixins: [validationMixin],
    validations(): any {
        return {
            editObject: this.getRules(),
        };
    },
    props: {
        /** Первичный ключ типа редактируемого объекта */
        primaryKey: {
            type: String,
            required: true,
            default: 'id'
        },
        /** Массив настроек полей формы */
        formSettings: {
            type: Object,
            required: true,
        },
        /** Выделенный для редактирования объект */
        selected: {
            type: Object,
            required: true,
        },
        /** Пустой дефолтный объект */
        emptyObject: {
            type: Object,
            required: true,
        },
        /** режим работы формы */
        editMode: {
            type: String,
            required: false,
            default: 'new'
        },
        /** Видимость формы */
        formShow: {
            type: Boolean,
            required: true,
            default: false
        },
        /** Текст формы создания */
        createFormTitle: {
            type: String,
            required: false,
            default: 'Создать запись'
        },
        /** Текст формы редактирования */
        editFormTitle: {
            type: String,
            required: false,
            default: 'Редактировать запись'
        },
        /** Заголвок диалогового окна удаления */
        deleteTitle: {
            type: String,
            required: false,
            default: 'Удалить запись'
        },
        /** Видимость формы удаления */
        deleteShow: {
            type: Boolean,
            required: true,
            default: false
        },
        /** Текст подтверждения диалогового окна удаления */
        deleteMessage: {
            type: String,
            required: false,
            default: 'Удалить выбранную запись?'
        },
        /** Наличие активного запроса к серверу */
        activeFormRequest: {
            type: Boolean,
            required: true,
            default: false
        },
        /** Наличие активной ошибки при запросе к серверу */
        failedFormRequest: {
            type: Boolean,
            required: true,
            default: false
        },
    },
    methods: {
        submitDeleteForm(): void {
            this.$emit('submit-delete-form', this.selected);
        },
        closeModalForm(): void {
            // refresh состояния системы валидации
            this.$nextTick(() => {
                this.$v.$reset();
            });
            this.$emit('close-modal-form');
        },
        submitForm(): void {
            // проверяем состояние валидации и если есть ошибки - прерываем выполнение
            this.$v.editObject.$touch();
            if (this.$v.editObject.$anyError) {
                return;
            }
            this.$emit('submit-form', this.editObject);
        },
        getEditObject(mode: string): any {
            // Чтобы объект, который мы редактируем не изменялся в таблице - нам в форме нужно работать с его копией
            // Если объект новый - так же создадим копию от шаблона новго компонента
            if (mode === 'edit' && this.selected !== undefined) {
                const newObject = Object.assign({}, this.selected);
                Object.keys(this.selected).forEach((key: string|number) => {
                    if (Array.isArray(this.selected[key])) {
                        newObject[key] = (this.selected[key] as Array<any>).slice(0);
                    }
                });
                return newObject;
            } else {
                const newObject = Object.assign({}, this.emptyObject);
                newObject[this.primaryKey] = uuidv4();
                Object.keys(this.emptyObject).forEach(
                    (key: string | number) => {
                        if (Array.isArray(this.emptyObject[key])) {
                            newObject[key] = (this.emptyObject[key] as Array<any>).slice(0);
                        }
                });
                return newObject;
            }
        },
        /** возвращает набор правил для валидации, извлекая их из настроек */
        getRules(): any {
            const rules = {} as any;

            this.formSettings.forEach(
                (element: {
                    validations: any | undefined;
                    name: string | number;
                    forNew: boolean | undefined; 
                }) => {
                    if (this.checkValidation(element))
                        rules[element.name] = element.validations;
                }
            );
            return rules;
        },
        checkValidation(element: { validations: any | undefined; name: string | number; forNew: boolean | undefined; }): boolean {
            return (
                element.validations !== undefined &&
                !(element.forNew === true && this.editMode === 'edit')
            );
        },
        validateState(name: string): boolean | null {
            const valResult = this.$v.editObject[name];
            if (valResult !== undefined) {
                return valResult.$dirty ? !valResult.$error : null;
            } else {
                return null;
            }
        },
        getActualsFields(): Array<any> {
            return this.formSettings.filter((item: { [x: string]: any; }) => {
                if (item['forNew'] !== undefined && item['forNew'] === true) {
                    return this.editMode === 'new';
                }
                return true;
            });
        },
    },
    watch: {
        editMode: function(newVal: string /**, oldVal */): void {
            this.editObject = this.getEditObject(newVal);
        },
        formShow: function(): void {
            this.editObject = this.getEditObject(this.editMode);
        },
    },
    computed: {
        formTitle(): string {
            return this.editMode === 'new'
                ? this.createFormTitle
                : this.editFormTitle;
        },
        formAction(): string {
            return this.editMode === 'new' ? 'Создать' : 'Сохранить';
        },
    },
    data() {
        return {
            editObject: undefined as any,
        };
    },
    mounted() {
        this.editObject = this.getEditObject(this.editMode);
    },
});
